<template>
  <div>
    <v-toolbar class="primary">
      <v-menu bottom offset-y>
        <v-btn flat slot="activator" dark>
          <v-icon dark>arrow_drop_down</v-icon>
          <v-toolbar-title class="white--text">{{ currentSegment }} Templates</v-toolbar-title>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item) in segments" :key="item.id" @click="selectSegment(item.name)">
            <v-list-tile-title>{{ item.name }} Templates</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn @click="createTemplate" flat dark><v-icon dark left>ballot</v-icon>
      <span>Create Template</span></v-btn>
      <v-btn v-if="templates.length > 0" @click="createTask" flat dark><v-icon dark left>edit</v-icon>
      <span>Create Task</span></v-btn>
    </v-toolbar>
    <v-card v-if="templates.length === 0">
      <v-card-title>You don't have any templates created. Let's create our first task template.</v-card-title>
    </v-card>
    <v-layout row v-if="templates.length > 0">
      <v-flex xs2>
        <v-toolbar class="secondary" dark flat>
          <v-toolbar-title>Task Templates</v-toolbar-title>
        </v-toolbar>
        <v-data-table :headers="templateHeaders" :items="templates" hide-actions class="elevation-1">
          <template slot="items" slot-scope="props">
            <div @click="selectedTemplate = props.item" :class="selectedTemplate.id === props.item.id ? 'orange white--text' : 'white black--text'">
              <v-layout align-center fill-height row style="cursor:pointer">
                <v-flex xs8 pl-3>
                  <strong>{{ props.item.name }}</strong>
                </v-flex>
                <v-flex xs2>
                  <v-btn @click="toggleActive(props.item)" icon flat><v-icon :color="selectedTemplate.id === props.item.id ? 'white' : 'black'">{{ props.item.active ? 'visibility' : 'visibility_off' }}</v-icon></v-btn>
                </v-flex>
                <v-flex xs2>
                  <v-btn @click="deleteTemplate(props.item)" icon flat><v-icon :color="selectedTemplate.id === props.item.id ? 'white' : 'black'">{{ 'delete' }}</v-icon></v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
        </v-data-table>
      </v-flex>
      <!-- Start of Tasks List Data -->
      <v-flex xs10 v-if="selectedTemplate && templateTasks.length > 0">
        <v-toolbar class="tertiary" dark flat>
          <v-toolbar-title>Task For: {{ selectedTemplate.name }} Template</v-toolbar-title>
        </v-toolbar>
        <v-data-table :headers="headers" :items="templateTasks" hide-actions class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr style="margin-left:100px">
              <!-- <td class="text-xs-left body-2 font-weight-bold handle">
                <v-icon>reorder</v-icon>
              </td> -->
              <td class="text-xs-left body-2 font-weight-bold" style="cursor:pointer" @click="editTaskTemplate(props.item)">
                <span class="ml-3">{{ props.item.displayName }}</span>
              </td>
              <td @click="editTaskTemplate(props.item)" style="cursor:pointer" class="text-xs-left">{{ props.item.phase }}</td>
              <td @click="editTaskTemplate(props.item)" style="cursor:pointer" class="text-xs-left">{{ props.item.task_starts }}</td>
              <td @click="editTaskTemplate(props.item)" style="cursor:pointer" class="text-xs-left">{{ props.item.displayDays }}</td>
              <td @click="editTaskTemplate(props.item)" style="cursor:pointer" class="text-xs-left">{{ props.item.required_upload ? 'Yes' : 'No' }}</td>
              <td @click="editTaskTemplate(props.item)" style="cursor:pointer" class="text-xs-left">{{ props.item.if_na ? 'Yes' : 'No' }}</td>
              <td @click="editTaskTemplate(props.item)" style="cursor:pointer" class="text-xs-left">{{ props.item.vendor_name }}</td>
              <!-- Assigned Users -->
              <td class="hidden-xs-only">
                <v-layout row wrap>
                  <v-tooltip top v-for="(assigned, index) in props.item.assignedUsers" :key="index">
                    <span>{{assigned.first_name + ' ' + assigned.last_name}}</span>
                    <v-avatar slot="activator" style="cursor: pointer">
                      <avatar :username="assigned.first_name + ' ' + assigned.last_name" :src="assigned.avatar ? assigned.avatar : undefined"></avatar>
                  </v-avatar>
                  </v-tooltip>
                </v-layout>
              </td>
              <!-- End: Assigned Users -->
              <td class="justify-center layout px-0" style="cursor: pointer">
                <v-icon small class="mr-2" @click="editTaskTemplate(props.item)">edit</v-icon>
                <v-icon small @click="deleteTemplateTask(props.item)"> delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex v-if="selectedTemplate && templateTasks.length <= 0">
        <v-toolbar class="tertiary" dark flat>
          <v-toolbar-title>No Task For: {{ selectedTemplate.name }} Template. Create your first task to get started.</v-toolbar-title>
        </v-toolbar>
      </v-flex>
      <!-- End of Tasks Data -->
    </v-layout>
  <!-- Create Template Dialog -->
  <v-dialog max-width="800px" persistent v-model="createTemplateDialog" v-if="createTemplateDialog">
    <template>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container class="white">
          <v-layout row wrap>
            <v-flex xs12 class="white--text primary">
              <v-card-title><h3 class="headline mb-0">Create New Task Template | {{ currentSegment }}</h3></v-card-title>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
          <v-flex xs12>
            <v-text-field style="max-width: 400px" v-model="newTemplate.name" :rules="nameRules" :counter="30" label="Template Name" required prepend-icon="ballot"></v-text-field>
          </v-flex>
          </v-layout>
          <v-layout v-if="templates && templates.length > 0">
            <v-flex xs12>
              <v-checkbox
                v-model="ifCopyTemplate"
                label="Copy Tasks From Template"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout v-if="ifCopyTemplate">
            <v-flex xs12 sm6 d-flex>
              <v-select
                v-model="templateCopy"
                :items="templateCopyDropdown"
                label="Select Task Template To Copy"
                outline
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-btn :disabled="!valid" flat class="primary" @click="saveTemplate"><v-icon left>edit</v-icon>Save and Close</v-btn>
              <v-btn flat class="secondary" @click="createTemplateDialog = false, ifCopyTemplate= false, templateCopy = null">Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </template>
  </v-dialog>
  <!-- Create Task Dialog -->
  <v-dialog max-width="800px" persistent v-model="createTaskDialog" v-if="createTaskDialog">
    <template>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container class="white">
          <v-layout row wrap>
            <v-flex xs12 class="white--text primary">
              <v-card-title><h3 class="headline mb-0">Create New Task | {{ selectedTemplate.name }}</h3></v-card-title>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field style="max-width: 400px" v-model="newTask.name" :rules="nameRules" :counter="30" label="Task Name" required prepend-icon="list"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-layout row>
                <v-select clearable v-model="newTask.phase" :items="projectPhasesDropDown" label="Phase" prepend-icon="file_copy"></v-select>
                <v-btn flat icon @click="editPhaseDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs12 md4>
              <v-select v-model="newTask.execution" @change="taskExecutionChanged = newTask.execution" :items="execution" :rules="validationRequired" label="Task Starts" required prepend-icon="insert_invitation"></v-select>
            </v-flex>
            <v-flex xs6 md5 v-if="newTask.execution === 'From Task Completion'">
              <v-select v-model="newTask.after_task" :items="tasksDropDown" :rules="validationRequired" label="After This Task Completes:" required prepend-icon=" "></v-select>
            </v-flex>
            <v-flex xs5 md5>
              <v-text-field v-model="newTask.days_due" :rules="validationRequired" :label="newTask.after_task ? 'Days Due From Task Completion' : 'Days until Due From Start Date'" required prepend-icon="today"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-layout row>
                <v-select clearable v-model="newTask.required_upload" :items="filesDropDown" label="Required File Upload" prepend-icon="file_copy"></v-select>
                <v-btn flat icon @click="editFileDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs3 md3 justify-end>
              <v-checkbox v-model="newTask.if_na" label="Allow N/A?" prepend-icon=" "></v-checkbox>
            </v-flex>
            <v-flex xs3 md3 justify-end>
              <v-checkbox v-model="newTask.showTaskOnReport" label="Show On Report Summary"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap mt-3>
          <!-- Start: Checklists -->
            <v-flex xs6>
              <v-toolbar height="40px" color="secondary" dark>
                <v-icon dark left>group</v-icon>
                <v-toolbar-title>Add Check Lists</v-toolbar-title>
              </v-toolbar>
              <v-text-field v-model="checkListItem" label="Add Checklist Item" prepend-icon="check"></v-text-field>
              <v-btn @click="addCheckListItems">Add Item</v-btn>
              <div class="mt-3" v-if="addedChecklistItems.length > 0">
                <v-toolbar height="40px" dark color="primary">
                  <v-toolbar-title class="subheading">Added Checklist Items</v-toolbar-title><span class="ml-3 caption">(Drag to Reorder)</span>
                </v-toolbar>
                <v-list>
                  <draggable v-model="addedChecklistItems" style="min-height: 10px">
                    <div v-for="(item, index) in addedChecklistItems" :key="index">
                      <v-tooltip top>
                        <v-list-tile slot="activator">
                          <v-list-tile-action>
                            <v-btn icon><v-icon>reorder</v-icon></v-btn>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title v-text="item"></v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon @click="deleteChecklistItem(index)">delete</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                        <span>{{item}}</span>
                      </v-tooltip>
                    </div>
                  </draggable>
                </v-list>
              </div>
            </v-flex>
            <v-flex xs6 pl-3>
              <!-- End: Checklists -->
              <!-- Start: Assigned Vendors -->
              <v-toolbar height="40px" color="secondary" dark>
                <v-icon dark left>group</v-icon>
                <v-toolbar-title>Assigned Vendor</v-toolbar-title>
              </v-toolbar>
              <v-btn flat @click="vendorSearch = true"><v-icon large class="pr-2" color="grey">assignment_ind</v-icon>Vendor: {{vendor_name ? vendor_name : 'No Vendor Assigned'}}</v-btn>
              <v-btn @click="removeVendor" v-if="newTask.vendor_id" flat icon><v-icon color="grey">cancel</v-icon></v-btn>
              <!-- End: Assigned Vendors -->
              <!-- Start: Assigned Users -->
              <v-toolbar height="40px" color="secondary" dark>
              <v-icon dark left>group</v-icon>
              <v-toolbar-title>Assigned Task Users</v-toolbar-title>
              <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-menu transition="slide-x-transition" bottom right>
                <v-btn dark flat icon slot="activator"><v-icon>person_add</v-icon></v-btn>
                  <v-list>
                    <v-list-tile v-for="(user, i) in userList" :key="i" @click="assignUser(user)">
                      <v-avatar class="mr-3">
                        <avatar :size="36" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>
                      </v-avatar>
                      <v-list-tile-title class="font-weight-strong">{{ user.first_name + ' ' + user.last_name }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-layout row wrap mt-3 ml-2 mb-3>
                <div v-if="assignedUsers.length > 0">
                  <div v-for="(user, i) in assignedUsers" :key="i">
                  <v-badge overlap color="grey" class="ml-2">
                  <span @click="removeAssignedUser(user)" style="cursor:pointer" slot="badge">X</span>
                  <v-avatar>
                    <v-tooltip top>
                      <avatar slot="activator" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>{{ user.first_name + ' ' + user.last_name }}
                    </v-tooltip>
                  </v-avatar>
                  </v-badge>
                  </div>
                  <span class="ml-2" v-if="assignedUsers.length < 1">No Assigned Users</span>
                </div>
              </v-layout>
            <!-- End: Assigned Users -->
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-btn :disabled="!valid" flat class="primary" @click="saveTask"><v-icon left>edit</v-icon>Save and Close</v-btn>
              <v-btn flat class="secondary" @click="closeForm">Cancel</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </template>
  </v-dialog>
  <!-- Edit File Drop Down -->
  <v-dialog max-width="600px" v-model="editFileDropdownDialog">
    <edit-dropdown v-if="editFileDropdownDialog" dropdownName="files" @closeDialog="editFileDropdownDialog = false"/>
  </v-dialog>
  <!-- Edit Project Phase Drop Down -->
  <v-dialog max-width="600px" v-model="editPhaseDropdownDialog">
    <edit-dropdown v-if="editPhaseDropdownDialog" dropdownName="projectPhases" @closeDialog="editPhaseDropdownDialog = false"/>
  </v-dialog>
  <!-- Vendor Search Dialog Box -->
  <v-dialog v-if="vendorSearch" v-model="vendorSearch" width="600px" height="400px">
    <vendor-search v-if="vendorSearch" @closeDialog="vendorSearch = false" @emittedVendor="emittedVendor" :isTemplateCreation="true" />
  </v-dialog>
  <!-- End: Vendor Search Dialog Box -->
</div>
</template>

<script>
import draggable from 'vuedraggable'
import Avatar from 'vue-avatar'
import VendorSearch from '../vendors/VendorSearch'
import _ from 'lodash'
import EditDropdown from '../../helpers/EditDropdown'

export default {
  props: ['segment'],
  created () {
    this.$store.dispatch('getTemplates')
  },
  mounted () {
    this.currentSegment = this.segment
    this.newTask = { ...this.newTaskTemplate }
  },
  watch: {
    selectedTemplate () {
      console.log('Selected Template', this.selectedTemplate)
    }
  },
  data () {
    return {
      vendorSearch: false,
      assignedUsers: [],
      templateCopy: null,
      ifCopyTemplate: false,
      selectedTemplate: null,
      newTemplate: { name: '' },
      createTemplateDialog: false,
      ifshowTaskOnReport: false,
      editPhaseDropdownDialog: false,
      editFileDropdownDialog: false,
      orderAfterTask: null,
      checkListItem: null,
      showAddChecklist: false,
      addedChecklistItems: [],
      taskList: [],
      createTaskDialog: false,
      taskExecutionType: 'new',
      taskExecutionChanged: null,
      segments: [{name: 'Pre-Construction'}, {name: 'Construction'}],
      currentSegment: 'Pre-Construction',
      phase: ['Starting', 'Permitting', 'Design', 'Engineering'],
      newTaskTemplate: {name: null, phase: null, execution: null, days_due: 0, after_task: null, if_required: false, if_na: false, required_upload: null, deleted: false, showTaskOnReport: true, taskId: null},
      newTask: null,
      editedTask: null,
      templateHeaders: [{ text: 'Name', value: 'name', sortable: false }],
      headers: [
        // { text: 'Reorder', value: 'order', sortable: false },
        { text: 'Task', value: 'name', sortable: false },
        { text: 'Phase', value: 'phase', sortable: false },
        { text: 'Task Starts', value: 'task_starts', sortable: false },
        { text: 'Days Until Due', value: 'days_due', sortable: false },
        { text: 'Required File?', value: 'required_upload', sortable: false },
        { text: 'Allow N/A?', value: 'if_na', sortable: false },
        { text: 'Vendor', value: 'vendor_name', sortable: false },
        { text: 'Assigned', value: 'assigned_to', sortable: false },
        { text: 'Actions', class: ['text-xs-center'], value: 'name', sortable: false }
      ],
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      valid: true
    }
  },
  computed: {
    vendor_name () {
      if (this.newTask && this.newTask.vendor_id) {
        const vendorList = this.$store.getters.vendorList
        const vendor = vendorList.filter(f => f.id === this.newTask.vendor_id)[0]
        return vendor.company_name
      }
    },
    templateCopyDropdown () {
      return this.templates.map(m => ({ text: m.name, value: m.id }))
    },
    templateTasks () {
      let taskList = this.$store.getters.getTemplateTasks
      if (taskList.length > 0) {
        const filteredTasks = taskList.filter(f => f.taskTemplateId === this.selectedTemplate.id && f.deleted === false)
        filteredTasks.forEach(task => {
          task.days_due = Number(task.days_due)
          task.order = task.days_due
          task.displayName = task.name
          task.task_starts = 'From Start Date'
        })
        // If Tasks Do Have a Dependancy
        let taskOrder = []
        let tasks = filteredTasks.filter(f => !f.after_task)
        let dependantTaskList = filteredTasks.filter(f => f.after_task)
        tasks = _.orderBy(tasks, ['order', 'name'])
        // Set Non-Dependancy Orders
        tasks.forEach(task => {
          taskOrder.push({ id: task.taskId, order: task.days_due })
        })
        // Loop through Non-Dependancy Hierarchys Adding Downstream orders
        tasks.forEach(task => {
          let dependantTasks = filteredTasks.filter(t => t.after_task === task.taskId)
          while (dependantTasks !== null && dependantTasks.length > 0) {
            let nextDependencies = []
            dependantTasks.forEach(dep => {
              const parentOrder = taskOrder.filter(f => f.id === dep.after_task)[0]
              const orderIdValues = taskOrder.map(m => m.id)
              if (parentOrder && !orderIdValues.includes(dep.taskId)) {
                taskOrder.push({ id: dep.taskId, order: dep.days_due + parentOrder.order })
              }
              let nextDependantTasks = dependantTaskList.filter(t => t.after_task === dep.taskId)
              if (nextDependantTasks && nextDependantTasks.length > 0) {
                nextDependencies = nextDependencies.concat(nextDependantTasks)
              } else {
                dependantTasks = null
              }
            })
            dependantTasks = nextDependencies
          }
        })
        tasks.map(m => { m.displayName = m.name })
        let dependantTasks = filteredTasks.filter(f => f.after_task)
        dependantTasks.forEach((task, i) => {
          const parentTask = filteredTasks.filter(t => t.taskId === task.after_task)[0]
          if (parentTask) {
            task.task_starts = 'After: ' + parentTask.name
            tasks.push(task)
          }
        })
        tasks.map(m => { m.displayDays = Math.floor(m.days_due) })
        // Get Vendor Names, Assignments, And Set Order
        tasks.forEach((task, i) => {
          // Set Vendors
          if (task.vendor_id) {
            const vendor = this.$store.getters.vendorList.filter(f => f.id === task.vendor_id)[0]
            tasks[i].vendor_name = vendor.company_name
          }
          // Set Assignments
          if (task.assigned_to && task.assigned_to.length > 0) {
            let assignedUsers = []
            task.assigned_to.forEach(assigned => {
              const user = this.$store.getters.userList.filter(f => f.id === assigned)[0]
              assignedUsers.push(user)
            })
            tasks[i].assignedUsers = assignedUsers
          }
          // Set Order
          const setTaskOrder = taskOrder.filter(f => f.id === task.taskId)[0]
          if (setTaskOrder && setTaskOrder.order) {
            task.order = setTaskOrder.order
          } else {
            task.order = task.days_due
          }
        })
        console.log(_.orderBy(tasks, ['order', 'name']))
        return _.orderBy(tasks, ['order', 'name'])
      } else {
        return []
      }
    },
    templates () {
      let getTemplates = this.$store.getters.getTemplates
      let taskTemplates = getTemplates.filter(template => template.type === this.currentSegment && template.deleted === false)
      let templates = _.orderBy(taskTemplates, ['active', 'name'], ['desc', 'asc'])
      if (!this.selectedTemplate) {
        this.selectedTemplate = templates[0]
      }
      return templates
    },
    execution () {
      return this.templateTasks.length > 0 ? ['From Start Date', 'From Task Completion'] : ['From Start Date']
    },
    projectPhasesDropDown () {
      let getPhasesDropDown = this.$store.getters.projectPhases
      // getPhasesDropDown.push('Pool Print', 'Jobsite Photos')
      return getPhasesDropDown.sort()
    },
    filesDropDown () {
      let getFileDropDown = this.$store.getters.files
      // getFileDropDown.push('Pool Print', 'Jobsite Photos')
      return getFileDropDown.sort()
    },
    orderAfterDropDown () {
      const filter = _.filter(this.tasks, {days_due: this.newTask.days_due})
      return _.map(filter, 'name')
    },
    tasksDropDown () {
      // let taskList = this.$store.getters.getTemplateTasks
      let taskList = this.selectedTemplate.tasks
      let items = []
      let taskOrder = _.orderBy(taskList, ['order', 'name'])
      // taskList.filter(f => f.taskTemplateId === this.selectedTemplate.id)
      taskOrder.forEach(item => {
        if (item.deleted === false) {
          items.push({ text: item.name, value: item.taskId })
        }
      })
      return items
    },
    user () {
      return this.$store.getters.user
    },
    userList () {
      return _.orderBy(this.$store.getters.userList, 'first_name')
    }
  },
  methods: {
    emittedVendor (vendor) {
      this.newTask.vendor_id = vendor.id
    },
    removeVendor () {
      this.newTask.vendor_id = null
    },
    assignUser (user) {
      if (!this.newTask.assigned_to && user) {
        this.newTask.assigned_to = []
      }
      if (user) {
        this.newTask.assigned_to.push(user.id)
      }
      // Add them to assignedUser Array
      let users = []
      if (this.newTask.assigned_to) {
        this.newTask.assigned_to.forEach(assigned => {
          const user = this.userList.filter(f => f.id === assigned)[0]
          users.push(user)
        })
      }
      this.assignedUsers = users
    },
    removeAssignedUser (user) {
      const userIndexId = this.newTask.assigned_to.findIndex(i => i === user.id)
      const userIndexObject = this.assignedUsers.findIndex(i => i.id === user.id)
      this.newTask.assigned_to.splice(userIndexId, 1)
      this.assignedUsers.splice(userIndexObject, 1)
    },
    log (title, message) {
      console.log(title, message)
    },
    toggleActive (template) {
      this.$store.dispatch('updateTemplate', { template: template, update: { active: !template.active } })
    },
    deleteTemplate (template) {
      this.selectedTemplate = null
      confirm('Are you sure you want to delete the task template ' + template.name + '?') &&
      this.$store.dispatch('updateTemplate', { template: template, update: { active: false, deleted: true } })
    },
    saveTemplate () {
      if (this.$refs.form.validate()) {
        let payload = { type: this.currentSegment, name: this.newTemplate.name, active: true }
        let taskTemplate = null
        if (this.templateCopy) {
          taskTemplate = this.templates.filter(f => f.id === this.templateCopy)[0]
          payload = { ...payload, tasks: taskTemplate.tasks }
        }
        this.$store.dispatch('createTemplate', payload)
        this.createTemplateDialog = false
        this.ifCopyTemplate = false
        this.templateCopy = null
      }
    },
    createTemplate () {
      this.newTemplate = { name: '' }
      this.createTemplateDialog = true
    },
    closeForm () {
      this.createTaskDialog = false
      this.taskExecutionType = 'new'
      this.checkListItem = null
      this.showAddChecklist = false
      this.addedChecklistItems = []
      this.assignedUsers = []
    },
    deleteChecklistItem (index) {
      this.addedChecklistItems.splice(index, 1)
    },
    addCheckListItems () {
      this.addedChecklistItems.push(this.checkListItem)
      this.checkListItem = null
    },
    selectSegment (name) {
      this.selectedTemplate = null
      this.currentSegment = name
    },
    createTask () {
      this.newTask = { ...this.newTaskTemplate }
      this.taskExecutionType = 'new'
      this.createTaskDialog = true
    },
    saveTask () {
      if (this.$refs.form.validate()) {
        let payload = {createTemplateTask: this.newTask}
        this.newTask.days_due = Number(this.newTask.days_due)
        delete payload.createTemplateTask.after_task_name
        delete payload.createTemplateTask.task_starts
        delete payload.createTemplateTask.order
        const tasklist = []
        this.addedChecklistItems.forEach(item => {
          const obj = { name: item, created_date: new Date(), active: true, completed: null, completed_by: null, completed_date: null }
          tasklist.push(obj)
        })
        payload = {...payload.createTemplateTask, checklist: tasklist, taskTemplateId: this.selectedTemplate.id}
        if (this.taskExecutionChanged === 'From Start Date') {
          payload.after_task = null
        }
        payload = {createTemplateTask: payload, type: this.taskExecutionType}
        if (!this.selectedTemplate.tasks) {
          this.selectedTemplate.tasks = []
        }
        const selectedTemplateIndex = this.selectedTemplate.tasks.findIndex(i => i.taskId === payload.createTemplateTask.taskId)
        this.selectedTemplate.tasks.splice(selectedTemplateIndex, 1, payload.createTemplateTask)
        // Change "undefined" to NULL
        const objKeys = Object.keys(payload.createTemplateTask)
        objKeys.forEach(key => {
          if (payload.createTemplateTask[key] === undefined) {
            payload.createTemplateTask[key] = null
          }
        })
        this.$store.dispatch('saveTemplateTask', payload)
        if (this.selectedTemplate.tasks) {
          this.selectedTemplate.tasks.push(payload.createTemplateTask)
        } else {
          this.selectedTemplate.tasks = [payload.createTemplateTask]
        }
        this.taskExecutionChanged = null
        this.closeForm()
        // this.$store.dispatch('getTaskTemplateList', this.currentSegment)
      }
    },
    editTaskTemplate (item) {
      this.taskExecutionType = 'edit'
      this.editedTask = Object.assign({}, item)
      this.newTask = Object.assign({}, item)
      this.createTaskDialog = true
      if (this.newTask.checklist) {
        this.showAddChecklist = true
        this.newTask.checklist.forEach(item => {
          this.addedChecklistItems.push(item.name)
        })
      }
      this.assignUser()
    },
    deleteTemplateTask (item) {
      const payload = {taskId: item.taskId, taskTemplateId: this.selectedTemplate.id}
      const cannotDelete = this.selectedTemplate.tasks.filter(f => f.after_task === item.taskId)[0]
      if (cannotDelete) {
        alert('Can NOT delete this task as other tasks rely on it.')
      } else {
        const selectedTemplateIndex = this.selectedTemplate.tasks.findIndex(i => i.taskId === item.taskId)
        confirm('Are you sure you want to remove this task from the template?') && this.$store.dispatch('deleteTemplateTask', payload) && this.selectedTemplate.tasks.splice(selectedTemplateIndex, 1)
      }
    }
  },
  components: {
    draggable,
    EditDropdown,
    Avatar,
    VendorSearch
  }
}
</script>

<style scoped>
  table.table tbody td {
    font-size: 20px;
  }
  .handle {
    cursor: move !important;
    cursor: -webkit-grabbing !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/tasks/TaskTemplates.vue